/*
 * Desarrollado por Saul Gonzalez Villafranca (RFC:GOVS7612304W2)
 * Copyright (c) 2019. Todos los derechos reservados
 */

function validaempresanueva() {
    res = "";
    if (_('txtNombre').value === "") {
        res += "Falta el nombre comercial.<br>";
    }
    if (_('txtRazon').value === "") {
        res += "Falta la raz&oacute;n social de la empresa.<br>";
    }
    if (_('txtRfc').value === "") {
        res += "Falta el RFC.<br>";
    }
    if (_('txtDir').value === "") {
        res += "Falta la direccion. <br>";
    }
    if (_('txtDir2').value === "") {
        res += "Falta la direccion. <br>";
    }
    if (_('txtTelefono').value === "") {
        res += "Falta el tel&eacute;fono. <br>";
    }
    if ((_('txtemail').value !== "") && (!validateEmail(_('txtemail').value))) {
        res += "El correo electronico no es valido.<br>";
    }
    if (_('cboCiudad')) {
        if (_('cboCiudad').value === 0) {
            res += "Necesita seleccionar una ciudad<br>";
        }
    } else {
        res += "Necesita seleccionar un estado, despues la ciudad<br>";
    }
    if (res !== "") {
        Swal.fire('Error!',"Se encontraron algunos errores:<br><br>" + res + "<br>Favor de corregirlos antes de guardar.",'error');
        return false;
    } else { return true; }
}

function guardarEmpresa() {
    _('btnGuardar').style = 'display: none;';
    Swal.fire({
        title: 'Generando base de datos y registro de la empresa, esta operaci&oacute;n tarda varios minutos, por favor no cierre el navegador.',
        onBeforeOpen: () => {
            Swal.showLoading()
            $.ajax({
                type: "POST",
                url: "../central/empresas.php",
                data: {
                    accion: txtaccion.value,
                    nombre: txtNombre.value,
                    idempresa: _('idempresa').value,
                    email: txtemail.value,
                    razon: txtRazon.value,
                    telefono: txtTelefono.value,
                    rfc: txtRfc.value,
                    dir: txtDir.value,
                    dir2: txtDir2.value,
                    idciudad: _('cboCiudad').value
                }
            }).done(function (data) {
                _('contenido').innerHTML = data;
                setTimeout(function () {
                    formatoTabla(true, true, false, true, false, true, true);
                }, 1000);
                swal.close();
            });
        },allowOutsideClick: () => !Swal.isLoading()
    });
}

function empresa_guarda_config(idempresa) {
    var indirectos = "0,0,0,0,0,0";
    if (_('chkindirecto0').checked) { indirectos = "1,";} else { indirectos = "0,"; }
    if (_('chkindirecto1').checked) { indirectos += "1,";} else { indirectos += "0,"; }
    if (_('chkindirecto2').checked) { indirectos += "1,";} else { indirectos += "0,"; }
    if (_('chkindirecto3').checked) { indirectos += "1,";} else { indirectos += "0,"; }
    if (_('chkindirecto4').checked) { indirectos += "1,";} else { indirectos += "0,"; }
    if (_('chkindirecto5').checked) { indirectos += "1";} else { indirectos += "0"; }
    $.ajax({
        url: '../central/select.php?tipo=43&idempresa='+ idempresa +'titulo=' + _('txttitulo').value + '&titulomenu=' + _('txttitulomenu').value + '&siglas=' + _('txttitulomin').value + '&logo=' + _('archlogo').value + '&indirectos=' + indirectos + '&seguridad=' + _('txtSegundos').value,
        success: function (data) {
            ajaxpage('inicio.php','contenido');
        }
    });
}

function validadominio(idempresa){
    _('divvalidadominio').innerHTML="<img src='../common_files/img/cargando.gif' with='200px' height='200px' >";
    $.ajax({
        url: '../central/select.php?tipo=49&idempresa='+ idempresa +'&dominio=' + _('txtDominio').value,
        success: function (data) {
            if (Number(data.split(',')[0]) === 1) {
                _('txtDominioService').value = data.split(",")[1] + _('txtDominio').value;
                _('divlogosindominio_validado').style = "display: inline;";
                _('divlogosindominio').style = "display: none;";
                _('divvalidadominio').innerHTML = "<br><br><label class='text-danger'>" + data.split(",")[1] + _('txtDominio').value + "</label> <img src='../common_files/img/checkmark.png' width='50px' height='50px' >";
            } else {
                _('divvalidadominio').innerHTML = "<br><br><label class='text-danger'>Ups, al parecer este dominio apunta a otra direcci&oacute;n ip, debe de estar apuntando a " + data + ". Esto lo puede hacer en su registro de dominio, agrege un alias con esta ip y su subdominio.</label>";
            }
        }
    });
}

function empresa_guarda_menu(idempresa){
    var idmenu = "";
    var items = $('[id^=chkmenu][type=checkbox]');
    for (var i=0;i<items.length;i++){
        if (items[i].checked){
            if (idmenu !== "") { idmenu += "#"; }
            idmenu += "" + items[i].id.split('chkmenu')[1] + ";";
            var subidmenu = "";
            var items_sub = $('[id^=chksubmenu' + items[i].id.split('chkmenu')[1] + '_][type=checkbox]');
            for (var j=0;j<items_sub.length;j++){
                if (items_sub[j].checked){
                    if (subidmenu !== "") { subidmenu += ","; }
                    subidmenu += "" + items_sub[j].id.split('_')[1];
                }
            }
            idmenu += subidmenu;
        }
    }

    Swal.fire({
        title: 'Guardando modulos, por favor espere...',
        onBeforeOpen: () => {
            Swal.showLoading()
            $.ajax({
                type: "POST",
                url: "../central/select.php?tipo=44",
                data: {
                    idempresa: idempresa,
                    menu: idmenu
                }
            }).done(function (data) {
                ajaxpage('inicio.php','contenido');
                swal.close();
            });
        },allowOutsideClick: () => !Swal.isLoading()
    });
}

async function pos_cambia_cant(opcion,datos){
    datos = Base64.decode(datos);
    let idarticulo = datos.split(';')[0];
    let precio = Base64.decode(datos.split(';')[2]);
    let marca = Base64.decode(datos.split(';')[3]);
    let modelo = Base64.decode(datos.split(';')[4]);
    let existencia = datos.split(';')[5];
    let descripcion = Base64.decode(datos.split(';')[6]);

    const {value: valores} = await Swal.fire({
        title: 'Cantidad:',
        html:
            '<input id="swal-input1" class="swal2-input" value="" placeholder="Cantidad" autocomplete="off">',
        focusConfirm: false,
        preConfirm: () => {
            return [
                document.getElementById('swal-input1').value
            ]
        }
    });
    if (valores) {
        var cantidad = Number(valores[0]);
        elimina_elemento(opcion, idarticulo);
        clsCarrito.eliminar(idarticulo);
        if (cantidad == 0)
            return 0;
        pos_agregar(idarticulo, existencia, Base64.encode(marca), Base64.encode(modelo), Base64.encode(descripcion), Base64.encode(precio), false, cantidad);
    }

}

function pos_agregar(idarticulo, existencia, marca, modelo, descripcion, precio, load = false,cantidad = 1){
    marca = Base64.decode(marca);
    modelo = Base64.decode(modelo);
    descripcion = Base64.decode(descripcion);
    precio = Base64.decode(precio);

    _('divbusqueda').style='display: none;';
    if (existencia < cantidad)
        _('txtcotizacion').value = 1;

    var tabla = _('tblcarrito');
    if (tabla.getElementsByTagName("tr").length > 1) {
        tabla.deleteRow(tabla.getElementsByTagName("tr").length - 1);
        tabla.deleteRow(tabla.getElementsByTagName("tr").length - 1);
        tabla.deleteRow(tabla.getElementsByTagName("tr").length - 1);
        if (_('txtdescuento').value > 0)
            tabla.deleteRow(tabla.getElementsByTagName("tr").length - 1);
        }
    var row = tabla.insertRow(tabla.getElementsByTagName("tr").length);
    var linea = tabla.getElementsByTagName("tr").length - 1;
    var createClickHandler = function (datos) {
        return function () {
            pos_cambia_cant('tblcarrito', datos);
        };
    };
    row.onclick = createClickHandler(Base64.encode(idarticulo + ';' + cantidad + ';' + Base64.encode(precio) + ';' + Base64.encode(marca) + ';' + Base64.encode(modelo) + ';' + existencia + ';' + Base64.encode(descripcion)));
    row.title = "Clic para modificar cantidad";
    cell = row.insertCell(0);
    cell.innerHTML = marca;
    cell = row.insertCell(1);
    cell.innerHTML = modelo;
    cell = row.insertCell(2);
    cell.innerHTML = descripcion;
    cell = row.insertCell(3);
    cell.innerHTML = cantidad;
    cell = row.insertCell(4);
    cell.innerHTML = '$ ' + formatMoneda(Math.round(precio * 100, 2) / 100, 2);
    cell = row.insertCell(5);
    cell.innerHTML = '$ ' + formatMoneda(Math.round((precio * cantidad) * 100, 2) / 100, 2);
    if (!load) clsCarrito.agregar(idarticulo,Base64.encode(precio),cantidad,Base64.encode(marca),Base64.encode(modelo),Base64.encode(descripcion));
    foot_tabla_totales(6, 'tblcarrito', '5', false, -1);

    tabla.rows[tabla.rows.length - 1].cells[4].innerHTML = "SubTotal";
    let subtotal = Number(tabla.rows[tabla.rows.length - 1].cells[5].innerHTML.split('$')[1].trim().split('</label>')[0].split(',').join(''));
    let subtotal_tmp = subtotal;

    if (_('txtdescuento').value > 0) {
        row = tabla.insertRow(tabla.getElementsByTagName("tr").length);
        cell = row.insertCell(0);
        cell.innerHTML = "";
        cell = row.insertCell(1);
        cell.innerHTML = "";
        cell = row.insertCell(2);
        cell.innerHTML = "";
        cell = row.insertCell(3);
        cell.innerHTML = "";
        cell = row.insertCell(4);
        cell.innerHTML = "Descuento";
        cell = row.insertCell(5);
        cell.innerHTML = '<label>$ ' + formatMoneda(Math.round((subtotal_tmp * (_('txtdescuento').value / 100)) * 100, 2) / 100, 2) + '</label>';
        subtotal_tmp -= Math.round((subtotal_tmp * (_('txtdescuento').value / 100)) * 100, 2) / 100;
    }

    row = tabla.insertRow(tabla.getElementsByTagName("tr").length);
    cell = row.insertCell(0);
    cell.innerHTML = "";
    cell = row.insertCell(1);
    cell.innerHTML = "";
    cell = row.insertCell(2);
    cell.innerHTML = "";
    cell = row.insertCell(3);
    cell.innerHTML = "";
    cell = row.insertCell(4);
    cell.innerHTML = "IVA (" + _('cboiva').value + " %)";
    cell = row.insertCell(5);
    cell.innerHTML = '<label>$ ' + formatMoneda(Math.round((subtotal_tmp * (_('cboiva').value / 100)) * 100, 2) / 100, 2) + '</label>';

    row = tabla.insertRow(tabla.getElementsByTagName("tr").length);
    cell = row.insertCell(0);
    cell.innerHTML = "";
    cell = row.insertCell(1);
    cell.innerHTML = "";
    cell = row.insertCell(2);
    cell.innerHTML = "";
    cell = row.insertCell(3);
    cell.innerHTML = "";
    cell = row.insertCell(4);
    cell.innerHTML = "TOTAL";
    cell = row.insertCell(5);
    cell.innerHTML = '<label>$ ' + formatMoneda(Math.round((subtotal_tmp * (1 + (_('cboiva').value / 100))) * 100, 2) / 100, 2) + '</label>';
    _('txttotal').innerHTML = "Total: ( " + numeroALetras(Math.round((subtotal_tmp * (1 + (_('cboiva').value / 100))) * 100, 2) / 100,2) + " )";
    if (subtotal > 0)
        _('btnPagar').disabled = false;

}

async function pos_nota_refresh(idventa=0,idcotizacion=0, tipo = 1){
    await $.ajax({
        url: 'generar_pdf_venta.php',
        type: "post",
        data: {
            v: idventa,
            c: idcotizacion,
            pago: Base64.encode(_('cbopago').options[_('cbopago').selectedIndex].text),
            usocfdi: Base64.encode(_('cbousocfdi').options[_('cbousocfdi').selectedIndex].text),
            dirigido: Base64.encode(_('lbldirigido').innerText),
            condicion: Base64.encode(_('lblcondiciones').innerText),
            tiempoentrega: _('lbltiempoentrega').innerText,
            comentarios: Base64.encode(_('txtComentarios').value),
            totalletra: Base64.encode(_('txttotal').innerHTML),
            vigencia: _('lblvigencia').innerText,
            t: tipo
        },
        success: async function (data) {
            jsonVenta = JSON.parse(Base64.decode(data));
            if (idventa === 0){
                let tabla = _('tblcarrito');
                for(let i=1;i<tabla.getElementsByTagName("tr").length;i++){
                    jsonVenta.pdf.content[2][0].table.body.push([
                        {"text":tabla.rows[i].cells[0].innerText,"style":"style_cuerpo"},
                        {"text":tabla.rows[i].cells[1].innerText,"style":"style_cuerpo"},
                        {"text":tabla.rows[i].cells[2].innerText,"style":"style_cuerpo"},
                        {"text":tabla.rows[i].cells[3].innerText,"style":"style_cuerpo","alignment":"right"},
                        {"text":tabla.rows[i].cells[4].innerText,"style":"style_cuerpo","alignment":"right"},
                        {"text":tabla.rows[i].cells[5].innerText,"style":"style_cuerpo","alignment":"right"}
                    ]);
                }
            }
            await generar_PDF_funciones(Base64.encode(JSON.stringify(jsonVenta)),(tipo === 1)?"venta":"venta2","ver","divimprimir",'');
        }
    });
}

async function pos_guardar(idCliente){
    //select 78
    var tabla = _('tblcarrito');
    var Total = Number(tabla.rows[tabla.rows.length - 1].cells[5].innerHTML.split('$')[1].trim().split('</label>')[0].split(',').join(''));
    $.ajax({
        type: "POST",
        url: "select.php?tipo=78",
        data: {
            idcliente: idCliente,
            pago: _('cbopago').value,
            metodo: _('cbometodopago').value,
            usocfdi: _('cbousocfdi').value,
            iva: _('cboiva').value,
            total: Total,
            descuento: _('txtdescuento').value,
            items: JSON.stringify(clsCarrito),
            jsonpdf: JSON.stringify(jsonVenta)
        }
    }).done(function (data) {
        // todo: agregar si es igual a cero un mensaje de error, no se pudo guardar
        if (Number(data) > 0) {
            clsCarrito = new Carrito();
            menu_punto_venta();
        } else {
            Swal.fire('Error!',"No se guardo la venta !",'error');
        }
    });
}

function pos_muestra_pago(){
    _('divposcanasta').style='display: none;';
    _('divpospago').style='display: inline;';
    if (_('txtcotizacion').value == 1){
        _('divpospagotarjeta').style="display: none;";
        _('divpospagoefectivo').style="display: none;";
    }
}

async function pos_guardar_cotizacion(idCliente) {
    var tabla = _('tblcarrito');
    var Total = Number(tabla.rows[tabla.rows.length - 1].cells[5].innerHTML.split('$')[1].trim().split('</label>')[0].split(',').join(''));
    $.ajax({
        type: "POST",
        url: "select.php?tipo=79",
        data: {
            idcliente: idCliente,
            total: Total,
            iva: _('cboiva').value,
            descuento: _('txtdescuento').value,
            items: JSON.stringify(clsCarrito),
            dirigido: _('lbldirigido').innerText,
            condicion: _('lblcondiciones').innerText,
            tiempoentrega: _('lbltiempoentrega').innerText,
            comentarios: _('txtComentarios').value,
            vigencia: _('lblvigencia').innerText,
            jsonpdf: JSON.stringify(jsonVenta)
        }
    }).done(function (data) {
        // todo: agregar si es igual a cero un mensaje de error, no se pudo guardar
        if (Number(data) > 0) {
            clsCarrito = new Carrito();
            menu_punto_venta();
        } else {
            Swal.fire('Error!',"No se guardo la cotizacion !",'error');
        }
    });
}

function pos_buscar(buscar,fix){
    buscar = Base64.decode(buscar);
    fix = Base64.decode(fix);
    if (buscar.length === 0) {
        _('divbusqueda').style='display: none;';
    } else {
        _('divbusqueda').style='display: inline;';
        $.ajax({
            type: "POST",
            url: "select.php?tipo=24",
            data: {forma_articulo:7,limite:10,busqueda:buscar,moneda:1,fix:fix}
        }).done(function (data) {
            _('listaarticulos').innerHTML = data;
            let items = document.getElementsByClassName('articuloPos');
            if (items.length === 1)
                if ((validaCodigoBarra(Base64.encode(buscar))) || (((!isNaN(parseFloat(buscar)) && isFinite(buscar)) && (buscar.length === 10)) && (Number(buscar[0].trim()) === 5))) {
                    items[0].click();
                    _('txtbuscarpos').value = "";
                }
        });
    }
}

function pos_iva(){
    var tabla = _('tblcarrito');
    tabla.deleteRow(tabla.getElementsByTagName("tr").length-1);
    tabla.deleteRow(tabla.getElementsByTagName("tr").length-1);
    var subtotal = Number(tabla.rows[tabla.rows.length - 1].cells[5].innerHTML.split('$')[1].trim().split('</label>')[0].split(',').join(''));
    jsonVenta.pdf.content[2][0].table.body.splice(jsonVenta.pdf.content[2][0].table.body.length - 2,2)
    if (_('txtdescuento').value > 0)
        subtotal = Number(tabla.rows[tabla.rows.length - 2].cells[5].innerHTML.split('$')[1].trim().split('</label>')[0].split(',').join(''));

    row = tabla.insertRow(tabla.getElementsByTagName("tr").length);
    cell = row.insertCell(0);
    cell.innerHTML = "";
    cell = row.insertCell(1);
    cell.innerHTML = "";
    cell = row.insertCell(2);
    cell.innerHTML = "";
    cell = row.insertCell(3);
    cell.innerHTML = "";
    cell = row.insertCell(4);
    cell.innerHTML = "IVA (" + _('cboiva').value + " %)";
    cell = row.insertCell(5);
    cell.innerHTML = '<label>$ ' + formatMoneda(Math.round((subtotal * (_('cboiva').value / 100)) * 100, 2) / 100, 2) + '</label>';

    row = tabla.insertRow(tabla.getElementsByTagName("tr").length);
    cell = row.insertCell(0);
    cell.innerHTML = "";
    cell = row.insertCell(1);
    cell.innerHTML = "";
    cell = row.insertCell(2);
    cell.innerHTML = "";
    cell = row.insertCell(3);
    cell.innerHTML = "";
    cell = row.insertCell(4);
    cell.innerHTML = "TOTAL";
    cell = row.insertCell(5);
    cell.innerHTML = '<label>$ ' + formatMoneda(Math.round((subtotal * (1 + (_('cboiva').value / 100))) * 100, 2) / 100, 2) + '</label>';
    _('txttotal').innerHTML = "Total: ( " + numeroALetras(Math.round((subtotal * (1 + (_('cboiva').value / 100))) * 100, 2) / 100,2) + " )";
    if (subtotal > 0)
        _('btnPagar').disabled = false;

    jsonVenta.pdf.content[2][0].table.body.push([
        {"text":"","style":"style_cuerpo"},
        {"text":"","style":"style_cuerpo"},
        {"text":"","style":"style_cuerpo"},
        {"text": "","style":"style_cuerpo"},
        {"text": "IVA (" + _('cboiva').value + " %)","style":"style_cuerpo","alignment":"right"},
        {"text": "$ " + formatMoneda(Math.round((subtotal * (_('cboiva').value / 100)) * 100, 2) / 100, 2),"style":"style_cuerpo","alignment":"right"}
    ]);
    jsonVenta.pdf.content[2][0].table.body.push([
        {"text":"","style":"style_cuerpo"},
        {"text":"","style":"style_cuerpo"},
        {"text":"","style":"style_cuerpo"},
        {"text": "","style":"style_cuerpo"},
        {"text": "Total","style":"style_cuerpo","alignment":"right"},
        {"text": "$ " + formatMoneda(Math.round((subtotal * (1 + (_('cboiva').value / 100))) * 100, 2) / 100, 2),"style":"style_cuerpo","alignment":"right"}
    ]);
    generar_PDF_funciones(Base64.encode(JSON.stringify(jsonVenta)),"venta","ver","divimprimir",'');

}

function getItemsSelect(tipo,params,div_tabla,formato_tabla,tabla_buscar){
    ajaxpage('../common_files/cargando.php',div_tabla);
    $.ajax({
        type: "POST",
        url: "select.php?tipo="+tipo,
        data: params
    }).done(function (data) {
        if (_(div_tabla) !== null){
            _(div_tabla).innerHTML = data;
            if (formato_tabla) { setTimeout(function() {formatoTabla(true,true,false,tabla_buscar,false,true,true);},500); }
        }
    });
    setTimeout(function() { $('[data-toggle="tooltip"]').tooltip(); },1000);
}

function getItemsCategoria(idcategoria){
    _('dropzone').style = 'display: inline;';
    $('.dropzone').each(function () {
        let dropzoneControl = $(this)[0].dropzone;
        if (dropzoneControl) { dropzoneControl.destroy();}}
    );

    setTimeout(function() {
        var drop = new Dropzone('div#dropzone', {
            url: '/desktop/subir_archivos.php',
            uploadMultiple: true,
            previewsContainer: '.dropzone-previews',
            parallelUploads: 1,
            timeout: 240000,
            maxFilesize: 10,
            maxFiles: 10,
            paramName: 'imgfoto',
            thumbnailWidth: 200,
            thumbnailHeight: 200,
            dictRemoveFile: 'Eliminar imagen',
            addRemoveLinks: true,
            params: {idcategoria:_('txtidcat').value,fotocat:1},
            acceptedFiles: 'image/*',
            init: function() {
                myDropzone = this;
                $('#dropzone').empty();
                $.ajax({
                    url: '/desktop/subir_archivos.php',
                    type: 'post',
                    data: {getimgcats:1,idcategoria:idcategoria},
                    dataType: 'json',
                    success: function(response){
                        $.each(response, function(key,value) {
                            let mockFile = { name: value.name, size: value.size, accepted: true };
                            myDropzone.emit("addedfile", mockFile);
                            myDropzone.emit("thumbnail", mockFile, value.url)
                            {
                                $('[data-dz-thumbnail]').css('height', '200');
                                $('[data-dz-thumbnail]').css('width', '200');
                                $('[data-dz-thumbnail]').css('object-fit', 'cover');
                            };
                            myDropzone.emit('complete', mockFile);
                            myDropzone.files.push(mockFile);
                        });
                    }
                });
            }
        });
        drop.on('success', function() {
            $.ajax({
                type: 'POST',
                url: '../prestashop_sync_ondemand.php',
                data: {
                    tipo: 7,
                    idarticulo: _('txtidcat').value,
                    idprestashop: _('txtidprestashop').value,
                    catalogo: "categories",
                    borrar: 1
                }
            });
        });
        _('dropzone').innerHTML += '<div class="dz-message needsclick"><span class="note needsclick">Arrastra la imagen para la categoria<br><small>Solo puedes seleccionar una imagen.</small></span></div>';
        _('dropzone').style = 'display: inline;'
    },500);
}

function getItemsDetalle(idarticulo,modelo,marca,idprestashop){
    txtidarticulo.value = idarticulo;
    _('dropzone').style = 'display: inline;';
    _('lblmodelo').innerHTML = modelo;
    _('lblmarca').innerHTML = marca;
    _('txtidprestashop').value = idprestashop;
    _('divbtnguardar').style='display: none';
    $('#tab1').addClass('active');
    $('#tab2').removeClass('active');
    _('dropzone').style='display: inline;';
    _('imgsearch').style='display: none;';
    $('.dropzone').each(function () {
        let dropzoneControl = $(this)[0].dropzone;
        if (dropzoneControl) { dropzoneControl.destroy();}}
        );
    setTimeout(function() {
        var drop = new Dropzone('div#dropzone', {
            url: '/desktop/subir_archivos.php',
            uploadMultiple: true,
            previewsContainer: '.dropzone-previews',
            parallelUploads: 10,
            timeout: 240000,
            maxFilesize: 10,
            maxFiles: 10,
            paramName: 'imgfoto',
            thumbnailWidth: 200,
            thumbnailHeight: 200,
            dictRemoveFile: 'Eliminar imagen',
            addRemoveLinks: true,
            removedfile: function(file) {
                var name = file.name;
                $.ajax({
                    type: 'POST',
                    url: '/desktop/subir_archivos.php',
                    data: {delimgitems:1,idarticulo:_('txtidarticulo').value,nombre:name},
                    dataType: 'html'
                });
                var _ref;
                return (_ref = file.previewElement) != null ? _ref.parentNode.removeChild(file.previewElement) : void 0;
            },
            params: {txtidarticulo:_('txtidarticulo').value,fotoitem:1},
            acceptedFiles: 'image/*',
            init: function() {
                myDropzone = this;
                $('#dropzone').empty();
                $.ajax({
                    url: '/desktop/subir_archivos.php',
                    type: 'post',
                    data: {getimgitems:1,idarticulo:idarticulo},
                    dataType: 'json',
                    success: function(response){
                        $.each(response, function(key,value) {
                            let mockFile = { name: value.name, size: value.size, accepted: true };
                            myDropzone.emit("addedfile", mockFile);
                            myDropzone.emit("thumbnail", mockFile, value.url)
                            {
                                $('[data-dz-thumbnail]').css('height', '200');
                                $('[data-dz-thumbnail]').css('width', '200');
                                $('[data-dz-thumbnail]').css('object-fit', 'cover');
                            };
                            myDropzone.emit('complete', mockFile);
                            myDropzone.files.push(mockFile);
                        });
                    }
                });
            }
        });
        drop.on('success', function() {
            $.ajax({
                type: 'POST',
                url: '../prestashop_sync_ondemand.php',
                data: {
                    tipo: 7,
                    idarticulo: idarticulo,
                    idprestashop: idprestashop,
                    catalogo: "products",
                    borrar: 0
                }
            });
        });

        _('dropzone').innerHTML += '<div class="dz-message needsclick"><span class="note needsclick">Arrastra las imagenes o da clic para seleccionarlas</span></div>';
        _('dropzone').style = 'display: inline;'
    },500);
}

async function inventario_salida_articulo(idanalisis,id,inventario,limite,idcategoria) {
    id = Base64.decode(id);
    limite = Base64.decode(limite);
    inventario = Base64.decode(inventario);
    const { value: valores } = await Swal.fire({
        title: 'Cantidad:',
        html:
            '<input id="swal-input1" class="swal2-input" value="" placeholder="Cantidad" autocomplete="off">',
        focusConfirm: false,
        preConfirm: () => {
            return [
                document.getElementById('swal-input1').value
            ]
        }
    });

    if (valores) {
        var cantidad = Number(valores[0]);
        if ((cantidad <= inventario) && ((inventario - cantidad) >= limite)){
            ajaxpage('inventario_salida.php?id=' + idanalisis + '&idarticulo=' + id + '&cantidad=' + cantidad + '&selec_empleado=1&idcategoria=' + idcategoria,'contenido');
        } else {
            if (cantidad > inventario){
                Swal.fire('Error!',"Inventario insuficiente, no ay articulos.",'error');
                return false;
            }
            if ((inventario - cantidad) < limite) {
                Swal.fire('Error!',"Supera el minimo que debe tener en stock.",'error');
                return false;
            }
        }
    }

}

async function inventario_devolucion_articulo(idanalisis,id,cantidad_salida) {
    id = Base64.decode(id);
    const { value: valores } = await Swal.fire({
        title: 'Cantidad:',
        html:
            '<input id="swal-input1" class="swal2-input" value="" placeholder="Cantidad" autocomplete="off">',
        focusConfirm: false,
        preConfirm: () => {
            return [
                document.getElementById('swal-input1').value
            ]
        }
    });

    if (valores) {
        var cantidad = Number(valores[0]);
        if (cantidad <= cantidad_salida) {
            ajaxpage('inventario_devolucion.php?id=' + idanalisis + '&idarticulo=' + id + '&cantidad=' + cantidad + '&selec_empleado=1','contenido');
        } else {
            Swal.fire('Error!',"La cantidad a devolver no puede ser mayor a la salida.",'error');
            return false;
        }
    }

}

function generarCFDI(idempresa){
    Swal.fire({
        title: 'Generando CFDI, esto puede tardar algunos minutos...',
        onBeforeOpen: () => {
            Swal.showLoading()

            // crear arreglos de unidades y desc de items
            let jsonFactura = JSON.parse(Base64.decode(_('txtjsonFactura').value));
            $('.cbounidadsat').each(function (){
                for (let i=0;i<jsonFactura.length;i++){
                    if (jsonFactura[i].sku == this.id.split('_')[1]) {
                        jsonFactura[i].unit_key = _(this.id).value.split('##')[0];
                        jsonFactura[i].unit_name = _(this.id).value.split('##')[1];
                        break;
                    }
                }
            });
            $('.txtdescitem').each(function (){
                for (let i=0;i<jsonFactura.length;i++){
                    if (jsonFactura[i].sku == this.id.split('_')[1]) {
                        jsonFactura[i].description = _(this.id).value;
                        break;
                    }
                }
            });
            $('.txtitemidsat').each(function (){
                for (let i=0;i<jsonFactura.length;i++){
                    if (jsonFactura[i].sku == this.id.split('_')[1]) {
                        jsonFactura[i].product_key = _(this.id).value;
                        break;
                    }
                }
            });

            $.ajax({
                type: "POST",
                dataType: "json",
                url: "crear_cfdi.php",
                data: {
                    idanalisis: _('txtAnalisis').value,
                    iva: _('txtiva').value,
                    formapago: _('cbopago').value,
                    metodopago: _('cbometodopago').value,
                    moneda: _('txtMoneda').value,
                    email: _('txtemail').value,
                    rfc: _('txtrfc').value,
                    usocfdi: _('cbousocfdi').value,
                    fix: _('txtFix').value,
                    nombre: _('txtNombre').value,
                    direccion: _('txtDireccion').value,
                    jsonitems: JSON.stringify(jsonFactura),
                    vendedor: _('txtvendedor').value,
                    ordencompra: _('txtordencompra').value,
                    proveedor: _('txtproveedor').value,
                    comentarios: _('txtcomentarios').value,
                    addenda: ($('#tieneAddenda').prop('checked'))?_('txtAddenda').value:''
               }
            }).done(function (data) {
                var idfactura = data.id;
                if (data.status == "valid"){
                    $.ajax({
                        url: "descarga.php?tipo=4&id=" + idfactura + '&idempresa=' + idempresa + '&idanalisis=' + _('txtAnalisis').value,
                        success: function (data) {
                            $.ajax({
                                url: 'facturacion_descarga.php?id=' + _('txtAnalisis').value,
                                success: function (data) {
                                    _('contenido').innerHTML = data;
                                    swal.close();
                                }
                            });
                        }
                    });
                } else {
                    Swal.fire('Error!', "No se pudo crear el CFDI.", 'error');
                    swal.close();
                }
            });
        },allowOutsideClick: () => !Swal.isLoading()
    });
}

function generarPin(){
    idanalisis = Number(_('txtidproyecto').value) - 6000000000;
    $.ajax({
        url: 'select.php?tipo=50&idanalisis=' + idanalisis,
        success: function (data) {
            _('lblpin').innerHTML = Number(Base64.decode(data));
        }
    });
    $('#btnaceptar').prop('disabled', true);
}

function getPin(){
    if (_('txtidproyecto').value.length === 10) {
        idanalisis = Number(_('txtidproyecto').value) - 6000000000;
        $.ajax({
            url: 'select.php?tipo=30&idanalisis=' + idanalisis,
            success: function (data) {
                if (Number(Base64.decode(data.trim())) == -1) {
                    Swal.fire('Error!', "Este proyecto ya esta terminado !", 'error');
                    _('txtidproyecto').value = "";
                    _('txtidproyecto').focus();
                } else if (Number(Base64.decode(data.trim())) == 0) {
                    Swal.fire('Error!', "Este proyecto no esta aceptado !", 'error');
                    _('txtidproyecto').value = "";
                    _('txtidproyecto').focus();
                } else {
                    _('lblpin').innerHTML = Number(Base64.decode(data).split(';')[0]);
                    $('#btnaceptar').prop('disabled', false);
                }
            }
        });
    } else {
        $('#btnaceptar').prop('disabled', true);
    }
}

function getImgMarcas(busqueda,extras,multiselect){
    if(multiselect){
        _('imgsearch').innerHTML = "<label>Selecciona las imagenes.</label><br>";
    } else {
        _('imgsearch').innerHTML = "<label>Selecciona una imagen de logotipo.</label><br>";
    }
    $.ajax({
        url: "https://www.googleapis.com/customsearch/v1?imgSize=LARGE&imgType=photo&key="+googleMapsApiKey+"&cx="+googleMapsApiKeySearch+"&q="+extras+busqueda+"&searchType=image",
        success: function (response) {
            //console.log(response);
            _('imgsearch').innerHTML = "";
            if (response.items !== undefined) {
                for (var i = 0; i < response.items.length; i++) {
                    var item = response.items[i];
                    // in production code, item.htmlTitle should have the HTML entities escaped.
                    _('imgsearch').innerHTML += "&nbsp;&nbsp;&nbsp;<img id=\"img" + i + "\" class=\"elevation-1 info-box-icon imgselect\" title=\"" + item.link + "\" style=\"cursor: pointer\" src=\"" + item.image.thumbnailLink + "\" onclick=\"imgGoogleClic(" + multiselect + ",'img" + i + "','" + item.link + "')\">&nbsp;&nbsp;&nbsp;";
                }
            } else {
                _('imgsearch').innerHTML = "<div class='col-sm-12 text-center'><label>No encontre nada !</label></div>";
            }
        }
    });

}

function subeImgGoogleCat(){
    var idcategoria = _('txtidcat').value;
    var idprestashop = _('txtidprestashop').value;
    if (_('txtimgurl').value !== "") {
        $.ajax({
            type: "POST",
            url: "subir_archivos.php",
            data: {ggoogleimgcat: 1, idcategoria: idcategoria,archivos: _('txtimgurl').value,},
        }).done(function (data) {
            if (_('tiendaurl').value !== "") {
                Swal.fire({
                    title: 'Subiendo imagen a',
                    html: '<b>Prestashop</b>',
                    onBeforeOpen: () => {
                        Swal.showLoading();
                        $.ajax({
                            type: 'POST',
                            url: '../prestashop_sync_ondemand.php',
                            data: {
                                tipo: 7,
                                idarticulo: idcategoria,
                                idprestashop: idprestashop,
                                catalogo: "categories",
                                borrar: 1
                            }
                        });
                        menu_sistema_categorias();
                        swal.close();
                    }, allowOutsideClick: () => !Swal.isLoading()
                });
            }
        });
    }
}

function subeImgGoogle(){
    var idarticulo = _('txtidarticulo').value;
    var idprestashop = _('txtidprestashop').value;

    Swal.fire({
        title: 'Subiendo imagen.',
        html: '<b>Espere por favor ...</b>',
        onBeforeOpen: () => {
            Swal.showLoading();
            $.ajax({
                type: "POST",
                url: "subir_archivos.php",
                data: {
                    ggoogleimgitems: 1,
                    archivos: _('txtimgurl').value,
                    idarticulo: idarticulo
                }
            }).done(function(data) {
                if (_('tiendaurl').value !== "") {
                    Swal.fire({
                        title: 'Subiendo imagen a',
                        html: '<b>Prestashop</b>',
                        onBeforeOpen: () => {
                            Swal.showLoading();
                            $.ajax({
                                type: 'POST',
                                url: '../prestashop_sync_ondemand.php',
                                data: {
                                    tipo: 7,
                                    idarticulo: idarticulo,
                                    idprestashop: idprestashop,
                                    catalogo: "products",
                                    borrar: 0
                                }
                            });
                            menu_inventario_imagenes();
                            swal.close();
                        },allowOutsideClick: () => !Swal.isLoading()
                    });
                } else {
                    menu_inventario_imagenes();
                    swal.close();
                }
            });
        },allowOutsideClick: () => !Swal.isLoading()
    });
}

function eliminaArticulo(idarticulo){
    Swal.fire({
        title: 'Eliminando articulo',
        html: '<b>Spartansoft</b>',
        onBeforeOpen: () => {
            Swal.showLoading();
            const content = Swal.getContent();
            ajaxpage('../common_files/cargando.php','contenido');
            $.ajax({
                type: "POST",
                url: "inventario_articulos_eliminar.php",
                data: {
                    eliminar: 1,
                    idarticulo: idarticulo
                }
            }).done(function(data) {
                _('contenido').innerHTML = data;
                if (_('tiendaurl').value !== "") {
                    if (content) {
                        const b = content.querySelector('b');
                        if (b) {
                            b.textContent = "Prestashop";
                        }
                    }
                    $.ajax({
                        url: '../prestashop_sync_ondemand.php',
                        type: 'post',
                        data: {
                            tipo: 4,
                            idarticulo: _('txtidprestashop').value
                        },
                        success: function (data) {
                            _('txtidprestashop').value = 0;
                            ajaxpage('inventario_articulos_eliminar.php?eliminar=1&idarticulo=<?= $rowarticulos[0]; ?>','contenido');
                            setTimeout(function() {formatoTabla(true,true,false,true,false,true,true,('csv,excel,pdf,print').split(','));},500);
                            swal.close();
                        }
                    });
                } else {
                    ajaxpage('inventario_articulos_eliminar.php?eliminar=1&idarticulo=<?= $rowarticulos[0]; ?>','contenido');
                    setTimeout(function() {formatoTabla(true,true,false,true,false,true,true,('csv,excel,pdf,print').split(','));},500);
                    swal.close();
                }
            });
        },allowOutsideClick: () => !Swal.isLoading()
    });
}

function eliminaMarca(idmarca){
    Swal.fire({
        title: 'Eliminando marca',
        html: '<b>Spartansoft</b>',
        onBeforeOpen: () => {
            Swal.showLoading();
            const content = Swal.getContent();
            ajaxpage('../common_files/cargando.php','contenido');
            $.ajax({
                type: "POST",
                url: "sistema_marcas.php",
                data: {
                    elimina: 1,
                    idmarca: idmarca
                }
            }).done(function(data) {
                _('contenido').innerHTML = data;
                if (_('tiendaurl').value !== "") {
                    if (content) {
                        const b = content.querySelector('b');
                        if (b) {
                            b.textContent = "Prestashop";
                        }
                    }
                    $.ajax({
                        url: '../prestashop_sync_ondemand.php',
                        type: 'post',
                        data: {
                            tipo: 5,
                            idmarca: _('txtidprestashop').value
                        },
                        success: function (data) {
                            _('txtidprestashop').value = 0;
                            ajaxpage('../common_files/cargando.php','divmarcas');
                            $.ajax({
                                url: "select.php?tipo=5"
                            }).done(function(data) {
                                _('divmarcas').innerHTML = data;
                            });
                            swal.close();
                        }
                    });
                } else {
                    ajaxpage('../common_files/cargando.php','divmarcas');
                    $.ajax({
                        url: "select.php?tipo=5"
                    }).done(function(data) {
                        _('divmarcas').innerHTML = data;
                    });
                    swal.close();
                }
            });
        },allowOutsideClick: () => !Swal.isLoading()
    });
}


function guardarMarca(){
    var nombre = _('txtNombre').value;
    Swal.fire({
        title: 'Guardando marca',
        html: '<b>Spartansoft</b>',
        onBeforeOpen: () => {
            Swal.showLoading();
            const content = Swal.getContent();
            ajaxpage('../common_files/cargando.php','contenido');
            $.ajax({
                type: "POST",
                url: "sistema_marcas.php",
                data: {
                    nuevo: (_('txtidmarca').value > 0)? 1:0,
                    idmarca: _('txtidmarca').value,
                    nombre: nombre,
                    idprestashop: _('txtidprestashop').value,
                    img: _('txtimgurl').value
                }
            }).done(function(data) {
                _('contenido').innerHTML = data;
                if (_('tiendaurl').value !== "") {
                    if (content) {
                        const b = content.querySelector('b');
                        if (b) {
                            b.textContent = "Prestashop";
                        }
                    }
                    $.ajax({
                        url: '../prestashop_sync_ondemand.php',
                        type: 'post',
                        data: {
                            tipo: 2,
                            idmarca: _('txtidmarca').value,
                            idprestashop: _('txtidprestashop').value,
                            marca: nombre
                        },
                        success: function (data) {
                            _('txtidmarca').value = 0;
                            _('txtidprestashop').value = 0;
                            ajaxpage('../common_files/cargando.php','divmarcas');
                            $.ajax({
                                url: "select.php?tipo=5"
                            }).done(function(data) {
                                _('divmarcas').innerHTML = data;
                            });
                            swal.close();
                        }
                    });
                } else {
                    ajaxpage('../common_files/cargando.php','divmarcas');
                    $.ajax({
                        url: "select.php?tipo=5"
                    }).done(function(data) {
                        _('divmarcas').innerHTML = data;
                    });
                    swal.close();
                }
            });
        },allowOutsideClick: () => !Swal.isLoading()
    });
}

function imgGoogleClic(multiselect,el,valor) {
    if (multiselect) {
        $('#'+el).toggleClass('img-thumbnail');
        $('#'+el).toggleClass('elevation-5');
        _('txtimgurl').value = "";
        $('.imgselect').each(function(){
            if (this.classList.contains('elevation-5')) {
                if (_('txtimgurl').value !== "") {
                    _('txtimgurl').value += "##";
                }
                _('txtimgurl').value += this.title;
            }
        });
    } else {
        _('txtimgurl').value = valor;
        $('.imgselect').removeClass('img-thumbnail');
        $('.imgselect').removeClass('elevation-5');
        $('#'+el).addClass('img-thumbnail');
        $('#'+el).addClass('elevation-5');
    }
}

function refreshSimular(){
    if (_('tabPaqueteArt')) {
        ajaxpage('select.php?tipo=55', 'tabPaqueteArt');
        /*
            $("div[id^='paquete_']").each( function (){ $(this).show(); });
        //    $("div[id^='divpaquete_']").each( function (){ $(this).hide(); });
            $("div[id^='divpaqres_']").each( function (){ $(this).hide(); });
            $("button[id^='btn']").each( function (){ $(this).show(); });
            for (var j=0;j<paquete_arr_opc.length;j++){
                var item = $('#divopc_'+paquete_arr_opc[j]);
                item.removeClass("card-success");
                item.addClass("card-primary");
            }
        */
        paquete_arr_opc = [];
        paquete_arr_art = [];
        paquete_ruta = "";
//    $("div[id^='divresumen_']").each( function (){ _($(this).attr('id')).innerHTML=""; });
    }
}

function paquete_agregar_opc(idpaquete,id,nombre,descripcion){
    var strOpc = "<div class=\"card card-primary card-solid\" style=\"cursor: pointer;\" onclick=\"paquete_clic(" + idpaquete + "," + id + ",'" + Base64.encode(nombre) + "');\" id=\"divopc_"+id+"\">\n" +
        "<div class=\"card-header with-border\"><h3 class=\"card-title\">" + nombre + "</h3>\n" +
        "</div><div class=\"card-footer\">\n" +
        "<label>" + descripcion + "</label></div></div>\n";
    $("#divgridpaquete").append(strOpc);
}

function pos_opciones_pago(){
    if (_('escotizacion').value == 1) {
        _('btnGuardarCotizacion').style = 'display:inline;';
        _('btnGuardar').style = 'display:none;';
        pos_nota_refresh(0, 0, 2);
        _('divposguardar').style = 'display: inline;';
        _('divpospago').style='display: none;';
        _('divposfactura').style='display: none;';
    } else {
        pos_nota_refresh();
        _('divposfactura').style='display: none;';
        _('divposguardar').style='display: inline;';
    }
}